<template lang="">
    <div>
        <!-- Generic Alert Dialog -->
        <md-dialog-alert
            :md-active.sync="error_dialog.show"
            :md-title="error_dialog.title"
            :md-content="error_dialog.content"
        />
        <group-card title="Billings" icon="real_estate_agent" padded>
            <template slot="actions">
                <md-button
                    class="md-icon-button md-primary md-simple"
                    @click="addNewBilling"
                >
                    <md-icon>add</md-icon>
                    <md-tooltip md-direction="top">Add New Billing</md-tooltip>
                </md-button>
                <loading-icon-button
                    @click="refreshBillings"
                    tooltip="Refresh"
                    :loading="progress_indicator.billings_list"
                >
                    cached
                </loading-icon-button>
            </template>
            <md-dialog :md-active.sync="show.edit_billing_dialog">
                <md-dialog-title>{{show.title}}</md-dialog-title>
                <div class="md-layout">
                    <!-- Billing Name -->
                    <validated-text-input
                        class="md-layout-item md-small-size-100 md-size-40"
                        label="Billing Name"
                        v-model="billing_details.name"
                    >
                    </validated-text-input>

                    <!-- Billing RCTI Descrption -->
                    <validated-text-input
                        class="md-layout-item md-small-size-100 md-size-40"
                        label="Billing RCTI description"
                        v-model="billing_details.rcti_description"
                    >
                    </validated-text-input>

                    <!-- Billing Type -->
                    <validated-text-input
                        class="md-layout-item md-small-size-100 md-size-20"
                        label="Billing Type"
                        v-model="billing_details.type"
                    >
                    </validated-text-input>

                    <!-- Account Code -->
                    <validated-text-input
                        class="md-layout-item md-small-size-100 md-size-20"
                        label="Account Code"
                        v-model="billing_details.account_code"
                    >
                    </validated-text-input>

                    <!-- Rate -->
                    <validated-text-input
                        class="md-layout-item md-small-size-100 md-size-20"
                        label="Rate"
                        v-model="billing_details.rate"
                    >
                    </validated-text-input>

                    <!-- Bill in bulk -->
                    <md-checkbox
                        class="md-layout-item md-small-size-100 md-size-20"
                        v-model="billing_details.bill_in_bulk"
                    >
                        Bill in Bulk
                    </md-checkbox>
                </div>

                <md-dialog-actions>
                    <md-button
                        class="md-primary md-simple"
                        @click="onEditBillingCancel"
                        >Cancel</md-button
                    >
                    <md-button
                        class="md-primary md-simple"
                        @click="onEditBillingSave"
                        >Save</md-button
                    >
                </md-dialog-actions>
            </md-dialog>
            <BillingList
                :items="billings"
                :loading="progress_indicator"
                @delete-billing="deleteBilling"
                @edit-billing="viewBilling"
            ></BillingList>
        </group-card>
    </div>
</template>
<script>
import { GroupCard } from "@/components";
import { mapGetters } from "vuex";
import LoadingIconButton from "@/components/LoadingIconButton";
import ValidatedInputs from "@/components/ValidatedInput";
import BillingList from "../components/BillingList";

export default {
    components: {
        GroupCard,
        LoadingIconButton,
        ...ValidatedInputs,
        BillingList,
    },
    data() {
        return {
            billings: [],
            show: {
                title : null,
                edit_billing_dialog: false,
            },
            progress_indicator: {
                billings_list: false,
                edit_billing_id: false,
                remove_billing_id: false,
            },
            billing_details: {
                id: null,
                name: null,
                type: null,
                rcti_description: null,
                account_code: "0",
                rate: "0",
                bill_in_bulk: false,
            },
            error_dialog: {
                show: false,
                title: null,
                content: null,
            },
        };
    },
    methods: {
        async getBillings(force = false) {
            this.progress_indicator.billings_list = true;
            const response = await this.$store.dispatch(
                "fetch_administration_billings",
                force
            );

            if (response) {
                this.billings = this.savedBillings();
            }
             this.progress_indicator.billings_list = false;
        },
        async onEditBillingSave() {
            let billingData = {
                ...this.billing_details,
                account_code:
                    this.billing_details.account_code.length === 0
                        ? "0"
                        : this.billing_details.account_code,
                rate:
                    this.billing_details.rate.length === 0
                        ? "0"
                        : this.billing_details.rate,
            };
            const response = await this.$store.dispatch(
                "save_administration_billings",
                billingData
            );

            this.show.edit_billing_dialog = false;
            if (200 <= response.status && response.status <= 299) {
                this.refreshBillings();
            } else {
                this.showDialog(
                    "Failed To Save Billing",
                    `The Billing cannot be save for some reasons - \n` +
                        response.data
                );
            }
        },
        async refreshBillings() {
            this.progress_indicator.billings_list = true;
            await this.getBillings(true);
            this.progress_indicator.billings_list = false;
        },
        async viewBilling(billing) {
            this.show.title = "Edit Billing"
            this.progress_indicator.edit_billing_id = billing.id;

            const response = await this.$store.dispatch(
                "fetch_administration_billing_detail",
                billing.id
            );
            this.setBilling(response.data);
            this.show.edit_billing_dialog = true;

            this.progress_indicator.edit_billing_id = null;
        },
        async deleteBilling(billing) {
            this.progress_indicator.remove_billing_id = billing.id;
            const response = await this.$store.dispatch(
                "remove_administration_billing_detail",
                billing.id
            );
            if (200 <= response.status && response.status <= 299) {
                this.refreshBillings();
                this.progress_indicator.remove_billing_id = null;
            } else {
                this.showDialog(
                    "Failed To Delete Billing",
                    `The Billing cannot be Delete for some reasons - \n` +
                        response.data
                );
                this.progress_indicator.remove_billing_id = null;
            }
        },
        onEditBillingCancel() {
            this.show.edit_billing_dialog = false;
        },
        addNewBilling() {
            this.show.title = "Add New Billing"
            this.resetBillings();
            this.show.edit_billing_dialog = true;
        },
        setBilling(billing) {
            this.billing_details = {
                id: billing.id,
                name: billing.name,
                type: billing.type,
                account_code: billing.account_code,
                rcti_description: billing.rcti_description,
                rate: billing.rate,
                bill_in_bulk: billing.bill_in_bulk
            };
        },
        resetBillings() {
            this.billing_details = {
                id: null,
                name: null,
                rcti_description: null,
                type: null,
                account_code: "0",
                rate: "0",
                bill_in_bulk: false
            };
        },
        showDialog(title, content) {
            this.error_dialog.title = title;
            this.error_dialog.content = content;
            this.error_dialog.show = true;
        },
    },
    created() {
        this.getBillings(true);
    },
    computed: {
        ...mapGetters({
            savedBillings: "administrationBillings",
        }),
    },
};
</script>
<style lang="scss" scoped></style>
